// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `angular-cli.json`.

  export const environment = {
    production: false,
    firebase: {
      apiKey: "AIzaSyBUhSg0t8gYYhddXrXolgYy4CHWTGeVKIM",
      authDomain: "softmart-beef5.firebaseapp.com",
      databaseURL: "https://softmart-beef5.firebaseio.com",
      projectId: "softmart-beef5",
      storageBucket: "softmart-beef5.appspot.com",
      messagingSenderId: "300399679940"
    }
  };



// WEBPACK FOOTER //
// ./src/environments/environment.ts